/**
 * AddEpisodeCtrl controller
 * Add/Edit Season TV Shows
 */

import { DRM_ACCOUNT_TYPES, PLATFORM_TYPES, RESOLUTIONS, TV_SHOW_IMAGES_TYPE, URL_PATTERN } from 'app/core/constants'
import moment from 'moment/moment'
import { formatDateByTimezone } from '../../app/helpers/date'
import { ensureOfflinePlaybackDefaults, resetOfflineExpirationIfDisabled } from '../../app/helpers/offlinePlayback'
import { openAssignContentSets } from '../common/directives/contentItems/ci.directives'

/**
 * AddEpisodeCtrl controller
 *
 * @class AddEpisodeCtrl
 * @memberof mwApp/seasons
 * @see mwApp/seasons
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/seasons.controller:AddEpisodeCtrl
 */
/* @ngInject */
export default function AddEpisodeCtrl ($state, $location, $uibModal, $scope, $rootScope, Episode, ShowSet, ep, season, show, extra, playbackTokenGenerators, authSvc, networks, alertLiteSvc, alertSvc) {
  var vm = this

  vm.urlPattern = URL_PATTERN

  /**
   * Resolutions
   *
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   * @type {String[]}
   */
  vm.resolutions = RESOLUTIONS

  /**
   * Images types for TV Show
   *
   * @memberOf mwApp/shows.controller:AddEpisodeCtrl
   * @type {Object}
   */
  vm.imagesType = TV_SHOW_IMAGES_TYPE

  /**
   * DRM account types
   *
   * @memberOf mwApp/channels.controller:AddEpisodeCtrl
   * @type {Object}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES

  /**
   * Episode
   *
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   * @type {models.Episode | models.SeasonEpisode}
   */
  vm.ep = ep
  ep.urls = ep.urls || {} // fake object if urls is null

  /**
   * Episode extra
   *
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   * @type {models.Episode.extra | models.SeasonEpisode.extra}
   */
  vm.extra = extra

  vm.show = show

  ensureOfflinePlaybackDefaults(ep)

  vm.networks = networks

  // parse drm profiles
  for (const prop in ep.urls) {
    if (Object.prototype.hasOwnProperty.call(ep.urls, prop)) {
      if (!ep.urls[prop]) {
        continue
      }

      if (ep.urls[prop].drmProfiles) {
        for (let i = 0; i < ep.urls[prop].drmProfiles.length; i++) {
          const findProfile = vm.extra.drmProfiles.find((dp) => dp.id === ep.urls[prop].drmProfiles[i].id)

          if (findProfile) {
            ep.urls[prop].drmProfiles[i] = angular.copy(findProfile)
          }
        }
      }
    }
  }

  /**
   * Show

  /**
   * Season
   *
   * @memberof mwApp/season.controller:AddEpisodeCtrl
   * @type {models.Season}
   */
  vm.season = season

  /**
   * isNew flag
   *
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   * @type {Boolean}
   */
  vm.isNew = ep._isNew()

  /**
   * Datepicker settings
   *
   * @memberof mwApp/reports.controller:AddEpisodeCtrl
   * @type {Object}
   */
  vm.dpCfg = {
    format: 'yyyy',
    datepickerMode: 'year',
    startingDay: 1,
    minMode: 'year',
    minDate: moment().year(1900).toDate(),
    maxDate: moment().set('year', moment().year() + 5).toDate()
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/reports.controller:AddStreamReportCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.openedFrom = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/reports.controller:AddStreamReportCtrl
   */
  vm.openTo = function () {
    vm.dpCfg.openedTo = true
  }

  /**
   * Disable not enable items
   * @param item
   * @returns {boolean}
   */
  vm.disableChoice = (item) => {
    return !item.enabled
  }

  /**
   * Platform types
   *
   * @memberof mwApp/shows.controller:AddStreamReportCtrl
   * @type {Object[]}
   */
  vm.platformTypes = angular.copy(PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB')
  }))

  // load extra
  vm.playbackTokenGenerators = playbackTokenGenerators

  // get Date object from duration/length
  ep.lengthISO = (function (l) {
    var hours = l ? +l.split(':')[0] : 0
    var minutes = l ? +l.split(':')[1] : 0
    var seconds = l ? +l.split(':')[2] : 0
    var date = new Date()
    date.setHours(hours)
    date.setMinutes(minutes)
    date.setSeconds(seconds)
    return date // .toISOString()
  })(ep.length)

  if (!vm.isNew) {
    for (var i = vm.platformTypes.length; i--;) {
      vm.platformTypes[i].checked = !!ep.urls[vm.platformTypes[i].name]
    }
  }

  /**
   * Create or edit episode, and close modal window afterwards
   *
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   */
  vm.lengthError = false
  vm.save = function (form) {
    for (const control of form.$$controls) {
      control.$setDirty()
      control.$validate()
    }
    if (!vm.ep.publishTime) {
      if (vm.ep.$scheduledPublishing) {
        vm.dpCfgEpisode.changeHandler(form)
      }
    }

    if (form.$invalid) {
      return
    }

    if (ep.lengthISO.getHours() === 0 && ep.lengthISO.getMinutes() === 0 && ep.lengthISO.getSeconds() === 0) {
      vm.lengthError = true
      return
    }
    vm.setDisable()

    // set length
    // can't do it inside _save() callback, because there is no 'lengthISO' property inside anymore
    ep.length = ('0' + ep.lengthISO.getHours()).slice(-2) + ':' + ('0' + ep.lengthISO.getMinutes()).slice(-2) + ':' + ('0' + ep.lengthISO.getSeconds()).slice(-2)

    if (!vm.ursulaEnabled) {
      for (var i = vm.platformTypes.length; i--;) {
        // remove url if checkbox isn't checked
        if (ep.urls && !vm.platformTypes[i].checked) {
          delete ep.urls[vm.platformTypes[i].name]
        }
        // deselect playback token generator
        if (vm.platformTypes[i].checked && !vm.platformTypes[i].extchecked) {
          ep.urls[vm.platformTypes[i].name].playbackTokenGeneratorId = null
        }
      }
    }
    resetOfflineExpirationIfDisabled(ep)

    ep._save((p) => {
      if (!p.urls) {
        p.urls = {}
      }
    }, ep._url, `${ep.title} episode added`, `${ep.title} episode updated`)
      .then(
        () => {
          ep._updateCustom(vm.ep.tvShow.id)
            .then((p) => {
              p.tvShow = ep.tvShow
            })
            .finally(
              () => {
                vm.unsetDisable()
              }
            )
        }
      )
      .then(vm.location(ep).reload)
      .then(vm.afterSaveActions)
      .finally(vm.unsetDisable)
  }

  vm.afterSaveActions = function () {
    if (vm.isNew && authSvc.hasAccess('editVodSeries')) {
      Episode.loadAvailableContentSets(ep.tvShow, ep.id)
        .then(data => {
          if (data.length) {
            alertSvc.confirm(`${ep.title} Episode has added. <br> Do You want to assign this Episode to the TV Show Set(s)?`)
              .then(() => {
                openAssignContentSets($state, $location, ep, true)
              })
          }
        })
    }
  }

  //
  // Upload images functional

  /**
   * Upload logo
   *
   * @param file
   * @param type
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return ep._uploadFile(ep._url + '/upload', file, {
      type
    }).data()
  }

  /**
   * Upload Portrait logo
   *
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   * @function
   */
  vm.uploadPortrait = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 2
      const heightPart = this.height / 3
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical poster aspect ratio must be 2:3')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, vm.imagesType.PORTRAIT)
        .then((response) => {
          ep.portraitImageUrl = response.resourceUrl
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Upload Background logo
   *
   * @memberof mwApp/shows.controller:AddEpisodeCtrl
   * @function
   */
  vm.uploadBackground = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 16
      const heightPart = this.height / 9
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical poster aspect ratio must be 16:9')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, vm.imagesType.BACKGROUND)
        .then((response) => {
          ep.backgroundImageUrl = response.resourceUrl
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Change Publish Now
   *
   * @memberof mwApp/episode.controller:AddEpisodeCtrl
   */
  vm.handleChangePublish = function () {
    if (vm.ep.enabled) {
      vm.ep.$scheduledPublishing = false
      vm.ep.$fromDate = new Date()
      vm.ep.$fromTime = new Date()
      vm.ep.$toDateUnlimited = true
    }
  }

  /**
   * Change Scheduled Publishing
   *
   * @memberof mwApp/episode.controller:AddEpisodeCtrl
   */
  vm.handleChangeScheduled = function () {
    if (vm.ep.$scheduledPublishing) {
      vm.ep.enabled = false
    }
  }

  /**
   * Episode datepicker settings
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.dpCfgEpisode = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (form, field = null) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateFrom.$setTouched()
        form.dateTo.$setTouched()
      }
      const fromDate = vm.ep.$fromDate && vm.ep.$fromDate.setHours(vm.ep.$fromTime.getHours(), vm.ep.$fromTime.getMinutes())
      const toDate = vm.ep.$toDate && vm.ep.$toDate.setHours(vm.ep.$toTime.getHours(), vm.ep.$toTime.getMinutes())
      const minDateStart = fromDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = toDate > formatDateByTimezone(Date.now(), false).valueOf()
      if (field === 'dateFrom' || !field) {
        form.dateFrom.$setValidity('minDate', minDateStart)
        form.dateFrom.$setValidity('after', true)

        if (fromDate && toDate) {
          const after = toDate > fromDate
          if (vm.ep.$toDateUnlimited) {
            form.dateFrom.$setValidity('after', true)
            form.dateTo.$setValidity('earlier', true)
          } else {
            if (form.dateTo.$error && form.dateTo.$error.earlier === true) {
              form.dateTo.$setValidity('earlier', after)
            }
            form.dateFrom.$setValidity('after', after)
          }
        }
      }
      if (field === 'dateTo' || !field) {
        form.dateTo.$setValidity('earlier', true)
        form.dateTo.$setValidity('minDate', true)
        if (!vm.ep.$toDateUnlimited) {
          form.dateTo.$setValidity('minDate', minDateEnd)
          if (fromDate && toDate) {
            const earlier = toDate > fromDate
            if (form.dateFrom.$error && form.dateFrom.$error.after === true) {
              form.dateFrom.$setValidity('after', earlier)
            }
            form.dateTo.$setValidity('earlier', earlier)
          }
        } else {
          form.dateFrom.$setValidity('after', true)
          form.dateFrom.$setValidity('earlier', true)
          form.dateTo.$setValidity('after', true)
          form.dateTo.$setValidity('earlier', true)
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.openSPFrom = function () {
    vm.dpCfgEpisode.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddSeasonCtrl
   */
  vm.openSPTo = function () {
    vm.dpCfgEpisode.toOpened = true
  }

  /**
   * Find provider type by platformName from selected profiles
   * @param platformName
   * @returns {Function}
   */
  vm.findSelectedProviderType = (platformName) => {
    const selectedProfile = vm.ep?.urls && vm.ep.urls[platformName]?.drmProfiles && vm.ep.urls[platformName].drmProfiles[0]
    if (!selectedProfile) {
      return null
    }

    return selectedProfile.providerType
  }

  /**
   * Change drm profile callback function
   * @param {string} platformName
   * @returns {Function}
   */
  vm.changeDrmProfile = (platformName) => {
    if (!vm.ep.urls[platformName].drmProfiles.length) {
      vm.ep.urls[platformName].kek = null
    }
  }

  vm.stbUrlAttention = function (url) {
    const webPlatform = vm.platformTypes.find(p => p.name === 'WEB')
    let webPlatformChecked = false
    if (webPlatform) {
      webPlatformChecked = webPlatform.checked
    }
    if (webPlatformChecked) {
      return false
    } else {
      return vm.urlAttention(url)
    }
  }

  vm.urlAttention = function (url) {
    if (url) {
      return url.slice(0, 7) === 'http://'
    } else {
      return false
    }
  }

  /**
   *  Filter for drm profiles
   * @param platformName
   * @returns {Function}
   */
  $scope.filterProfiles = function (platformName) {
    return function (profile) {
      if (!vm.ep.urls || !vm.ep.urls[platformName] ||
        !vm.ep.urls[platformName].drmProfiles ||
        !vm.ep.urls[platformName].drmProfiles.length) {
        return true
      }

      const selectedProviderType = vm.findSelectedProviderType(platformName)
      return profile.providerType === selectedProviderType &&
        !vm.ep.urls[platformName].drmProfiles.find((p) => p.drmType === profile.drmType)
    }
  }

  /**
   * table state
   *
   * @type {Object}
   */
  vm.tableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }

  /**
   * Delete content set item
   *
   * @memberof mwApp/packages.controller:AddEpisodeCtrl
   * @param index
   */
  vm.deleteContentSet = function (index) {
    $scope.form.$setDirty()
    vm.ep.contentSets.splice(index, 1)
  }

  $scope.$watch('vm.ep.lengthISO', (newValue, oldValue) => {
    vm.lengthError = oldValue !== newValue && vm.ep.lengthISO && vm.ep.lengthISO.getHours() === 0 && vm.ep.lengthISO.getMinutes() === 0 && vm.ep.lengthISO.getSeconds() === 0
  })

  $scope.$on('$viewContentLoaded', function () {
    vm.location.setGoBackLink('shows/' + vm.ep.tvShow.id)
  })

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  vm.ursulaEnabled = vm.hasFlag('FEATURE_URL_INTELLIGENCE_ENABLED')

  vm.extractPostersFromVideo = function (form) {
    $uibModal.open({
      templateUrl: 'components/shows/views/extractFromVideo.html',
      controller: 'ExtractFromVideo as vm',
      animation: false,
      size: 'lg',
      resolve: {
        playbackTokenGenerators: () => vm.playbackTokenGenerators
      }
    })
      .result
      .then(
        function close (poster) {
          vm.ep.portraitImageUrl = poster.vertical
          vm.ep.backgroundImageUrl = poster.horizontal
          form.$setDirty()
        },
        function dismiss () {

        }
      )
  }
}
